export default {
    coach: null,
    trainer_apply: null,
};



// WEBPACK FOOTER //
// ./src/store/trainer_apply/state.js